/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
/* eslint-disable eqeqeq */
import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';
import classNames from 'classnames';
import { Hyperlink, Image } from 'ts-paragon';

import messages from './messages';

const LargeLayout = () => {
  const { formatMessage } = useIntl();
  const siteConfig = getConfig();
  const customSiteSubtitle = siteConfig.CUSTOM_SITE_SUB_TITLE ? siteConfig.CUSTOM_SITE_SUB_TITLE : siteConfig.SITE_SUB_TITLE;
  const customSiteTitle = siteConfig.CUSTOM_SITE_TITLE ? siteConfig.CUSTOM_SITE_TITLE : siteConfig.SITE_TITLE;

  return (
    <div className="w-50 d-flex">
      <div className="col-md-9 bg-primary-400">
        <Hyperlink destination={getConfig().MARKETING_SITE_BASE_URL}>
          <Image className="logo position-absolute" alt={getConfig().SITE_NAME} src={getConfig().LOGO_WHITE_URL} />
        </Hyperlink>
        <div className="min-vh-100 d-flex align-items-center">
          <div className={classNames({ 'large-yellow-line mr-n4.5': getConfig().SITE_NAME === 'edX' })} />
          <h1
            className={classNames(
              'display-2 mw-xs',
              { 'ml-6': getConfig().SITE_NAME !== 'edX' },
              { 'text-white': (getConfig().SITE_NAME?.toLowerCase() ?? '')?.includes("asteralabs") }
            )}
          >
            {!customSiteSubtitle ? (
              <>
                {getConfig().SITE_TITLE ? getConfig().SITE_TITLE : 'Welcome to your program!'}
                <div className="text-accent-a">
                  {getConfig().SITE_SUB_TITLE}
                </div>
                {getConfig().SITE_NAME === 'CMU' && (
                  <p className="poweredby">Powered by TalentSprint</p>
                )}
              </>
            )
              : (
                <>
                  {customSiteTitle || 'Welcome to your program!'}
                  <div className={(getConfig().SITE_NAME?.toLowerCase() ?? '')?.includes("asteralabs") ? "text-white custom-site-subtitle" :"text-accent-a custom-site-subtitle"} style={(getConfig().SITE_NAME?.toLowerCase() ?? '')?.includes("asteralabs") ? {fontWeight: "900"} : {}}>
                    <span dangerouslySetInnerHTML={{ __html: customSiteSubtitle }} />
                  </div>
                </>
              )}

          </h1>
        </div>
      </div>
      <div className="col-md-3 bg-white p-0">
        <svg className="ml-n1 w-100 h-100 large-screen-svg-primary" preserveAspectRatio="xMaxYMin meet">
          <g transform="skewX(171.6)">
            <rect x="0" y="0" height="100%" width="100%" />
          </g>
        </svg>
      </div>
    </div>
  );
};

export default LargeLayout;
